
import React, {Component} from 'react';
import {withRouter} from "react-router-dom";

class Live extends Component {

    render(){
        return (
            <div> <p>Live</p> </div>
        )
    }
}

export default withRouter(Live);



// WEBPACK FOOTER //
// ./src/containers/live/live.js